import { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  NavDropdown,
} from "react-bootstrap";

import logo from "../assets/img/LogoSvg65.svg";
import navIcon1 from "../assets/img/nav-icon1.svg";

import { HashLink } from "react-router-hash-link";
import { Link, useLocation } from "react-router-dom";

export const NavBar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  const { pathname, hash } = location;

  /*
   * Koyu hero kullanan sayfalar
   * Bu sayfalarda en üstte navbar beyaz görünecek.
   */
  const darkHeroPages = [
    "/opal",
    "/startracker",
    "/products",
    "/industries",
  ];

  const isDarkHeroPage = darkHeroPages.some(
    (page) =>
      pathname === page ||
      pathname.startsWith(`${page}/`)
  );

  const navbarOnDark = isDarkHeroPage && !scrolled;

  /*
   * Aktif navbar bağlantıları
   */
  const isServicesActive =
    pathname === "/" && hash === "#skills";

  const isHomeActive =
    pathname === "/" && !isServicesActive;

  const isProductsActive =
    pathname === "/products" ||
    pathname.startsWith("/products/") ||
    pathname === "/opal" ||
    pathname.startsWith("/opal/") ||
    pathname === "/startracker" ||
    pathname.startsWith("/startracker/");

  const isIndustriesActive =
    pathname === "/industries" ||
    pathname.startsWith("/industries/");

  const isCompanyActive =
    pathname === "/company" ||
    pathname.startsWith("/company/");

  const isCareerActive =
    pathname === "/career" ||
    pathname.startsWith("/career/");

  /*
   * Scroll durumunu takip et
   */
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    onScroll();

    window.addEventListener("scroll", onScroll);

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [pathname]);

  return (
    <Navbar
      expand="md"
      className={`${scrolled ? "scrolled" : ""} ${
        navbarOnDark ? "navbar-on-dark" : ""
      }`}
    >
      <Container>
        {/* LOGO */}
        <Navbar.Brand
          as={HashLink}
          smooth
          to="/#home"
          aria-label="Kristal Fotonik Home"
        >
          <img src={logo} alt="Kristal Fotonik" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          aria-label="Open navigation menu"
        />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            {/* HOME */}
            <Nav.Link
              as={HashLink}
              smooth
              to="/#home"
              className={`navbar-link ${
                isHomeActive ? "active" : ""
              }`}
            >
              Home
            </Nav.Link>

            {/* SERVICES */}
            <NavDropdown
              title="Services"
              id="services-nav-dropdown"
              className={`navbar-link ${
                isServicesActive ? "active" : ""
              }`}
            >
              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/#skills"
              >
                Training Services
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/#skills"
              >
                Turnkey Product Development
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/#skills"
              >
                Consultancy Services
              </NavDropdown.Item>
            </NavDropdown>

            {/* PRODUCTS */}
            <NavDropdown
              title="Products"
              id="products-nav-dropdown"
              className={`navbar-link ${
                isProductsActive ? "active" : ""
              }`}
            >
              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/opal#opal"
              >
                Opal-1920S Visible Light Camera
              </NavDropdown.Item>

              <NavDropdown.Item
                as={Link}
                to="/startracker"
              >
                Star Tracker
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item
                as={Link}
                to="/products"
              >
                All Products
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#daylightV"
              >
                Daylight Vision IP Core
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#HDR"
              >
                HDR IP Core
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#IMR"
              >
                Image Resize IP Core
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#NonUni"
              >
                Non Uniformity Correction IP Core
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#TargetTrack"
              >
                Target Tracking IP Core
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/products#imstabi"
              >
                Digital Image Stabilization IP Core
              </NavDropdown.Item>
            </NavDropdown>

            {/* INDUSTRIES */}
            <NavDropdown
              title="Industries"
              id="industries-nav-dropdown"
              className={`navbar-link ${
                isIndustriesActive ? "active" : ""
              }`}
            >
              <NavDropdown.Item
                as={Link}
                to="/industries"
              >
                All Industries
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#Aerial"
              >
                Aerial and Satellites
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#Automation"
              >
                Automation
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#Healthcare"
              >
                Healthcare and Medical
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#MachineV"
              >
                Machine Vision
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#Robotic"
              >
                Robotics
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#ScientificR"
              >
                Scientific Research
              </NavDropdown.Item>

              <NavDropdown.Item
                as={HashLink}
                smooth
                to="/industries#SmartC"
              >
                Smart Cities
              </NavDropdown.Item>
            </NavDropdown>

            {/* COMPANY */}
            <Nav.Link
              as={Link}
              to="/company"
              className={`navbar-link ${
                isCompanyActive ? "active" : ""
              }`}
            >
              Company
            </Nav.Link>

            {/* CAREER */}
            <Nav.Link
              as={Link}
              to="/career"
              className={`navbar-link ${
                isCareerActive ? "active" : ""
              }`}
            >
              Career
            </Nav.Link>
          </Nav>

          <span className="navbar-text">
            {/* LINKEDIN */}
            <div className="social-icon">
              <a
                href="https://www.linkedin.com/company/kristal-fotonik"
                target="_blank"
                rel="noreferrer"
                aria-label="Kristal Fotonik LinkedIn"
              >
                <img src={navIcon1} alt="" />
              </a>
            </div>

            {/* CONTACT */}
            <HashLink smooth to="/#connect">
              <button className="vvd" type="button">
                <span className="vv">Contact</span>
              </button>
            </HashLink>
          </span>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};